export default "__VITE_ASSET__Bb5jn2Wn__"